import { render, staticRenderFns } from "./AnonymProject.vue?vue&type=template&id=660febc2&"
import script from "./AnonymProject.vue?vue&type=script&lang=js&"
export * from "./AnonymProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports